/**
 * fantasia.js
 * Disney Fantasia LP — US Shopify
 * No jQuery. No external libraries. Scoped to #jins-fantasia.
 */

(function () {
  'use strict';

  // ── PAGE GUARD ──
  if (!document.querySelector('#jins-fantasia')) return;

  // ── 1. FADE-IN REVEAL ──────────────────────────────────────
  (function initFadeIn() {
    var SELECTOR = '#jins-fantasia .jt-fn-fade-in';
    var VISIBLE  = 'is-visible';
    var targets  = document.querySelectorAll(SELECTOR);
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add(VISIBLE);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add(VISIBLE);
        observer.unobserve(entries[i].target);
      }
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    for (var j = 0; j < targets.length; j++) observer.observe(targets[j]);
  })();


  // ── 2. PRODUCT IMAGE SLIDERS ────────────────────────────────
  (function initSliders() {
    var sliders = document.querySelectorAll('#jins-fantasia [data-jt-fn-slider]');
    if (!sliders.length) return;

    function findAncestorByClass(el, className) {
      var node = el.parentElement;
      while (node) {
        if (node.classList && node.classList.contains(className)) return node;
        node = node.parentElement;
      }
      return null;
    }

    function initSlider(slider) {
      var slides = slider.querySelectorAll('.jt-fn-image-slide');
      if (!slides.length) return;

      var card = findAncestorByClass(slider, 'jt-fn-card');
      if (!card) return;

      var nav     = card.querySelector('.jt-fn-nav');
      if (!nav) return;

      var descEl        = card.querySelector('.jt-fn-desc');
      var dotsContainer = nav.querySelector('.jt-fn-nav-dots');
      var prevBtn       = nav.querySelector('.jt-fn-nav-arrow--prev');
      var nextBtn       = nav.querySelector('.jt-fn-nav-arrow--next');

      // Find initial active slide index
      var initialActive = -1;
      for (var k = 0; k < slides.length; k++) {
        if (slides[k].classList.contains('is-active')) { initialActive = k; break; }
      }
      var currentIndex = initialActive >= 0 ? initialActive : 0;
      var dots = [];

      // Build dots
      if (dotsContainer) {
        dotsContainer.textContent = '';
        for (var d = 0; d < slides.length; d++) {
          (function (index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'jt-fn-nav-dot' + (index === currentIndex ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Image ' + (index + 1));
            if (index === currentIndex) dot.setAttribute('aria-current', 'true');
            dot.addEventListener('click', function () { goTo(index); });
            dotsContainer.appendChild(dot);
            dots.push(dot);
          })(d);
        }
      }

      // Arrow listeners
      if (prevBtn) prevBtn.addEventListener('click', function () {
        goTo((currentIndex - 1 + slides.length) % slides.length);
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        goTo((currentIndex + 1) % slides.length);
      });

      // Set initial active state
      for (var s = 0; s < slides.length; s++) {
        if (s === currentIndex) {
          slides[s].classList.add('is-active');
          slides[s].removeAttribute('aria-hidden');
        } else {
          slides[s].classList.remove('is-active');
          slides[s].setAttribute('aria-hidden', 'true');
        }
      }

      // Update description text when slide changes
      function setDesc(index) {
        if (!descEl) return;
        var desc = slides[index].getAttribute('data-desc');
        if (desc === null) return;
        // Swap element to avoid iOS Safari ghost-text bug
        var newDesc = document.createElement('p');
        newDesc.className = descEl.className;
        newDesc.classList.add('is-visible');
        var parts = desc.split('\n');
        for (var p = 0; p < parts.length; p++) {
          if (p > 0) {
            var br = document.createElement('br');
            br.className = 'jt-fn-sp-br';
            newDesc.appendChild(br);
          }
          newDesc.appendChild(document.createTextNode(parts[p]));
        }
        descEl.parentNode.replaceChild(newDesc, descEl);
        descEl = newDesc;
      }

      function goTo(index) {
        if (index === currentIndex) return;
        slides[currentIndex].classList.remove('is-active');
        slides[currentIndex].setAttribute('aria-hidden', 'true');
        slides[index].classList.add('is-active');
        slides[index].removeAttribute('aria-hidden');
        if (dots[currentIndex]) {
          dots[currentIndex].classList.remove('is-active');
          dots[currentIndex].removeAttribute('aria-current');
        }
        if (dots[index]) {
          dots[index].classList.add('is-active');
          dots[index].setAttribute('aria-current', 'true');
        }
        setDesc(index);
        currentIndex = index;
      }

      // Touch/swipe support
      var SWIPE_THRESHOLD = 50;
      var swipeStartX = null;
      var swipeStartY = null;
      var swipeLastX  = null;
      var swipeLastY  = null;

      function resetSwipe() { swipeStartX = null; swipeStartY = null; }

      slider.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches.length) return;
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
        swipeLastX  = swipeStartX;
        swipeLastY  = swipeStartY;
      }, { passive: true });

      slider.addEventListener('touchmove', function (e) {
        if (!e.touches || !e.touches.length) return;
        swipeLastX = e.touches[0].clientX;
        swipeLastY = e.touches[0].clientY;
      }, { passive: true });

      slider.addEventListener('touchend', function () {
        if (swipeStartX === null) return;
        var dx = swipeLastX - swipeStartX;
        var dy = swipeLastY - swipeStartY;
        resetSwipe();
        if (Math.abs(dx) < SWIPE_THRESHOLD) return;
        if (Math.abs(dy) > Math.abs(dx)) return;
        goTo(dx < 0
          ? (currentIndex + 1) % slides.length
          : (currentIndex - 1 + slides.length) % slides.length
        );
      }, { passive: true });

      slider.addEventListener('touchcancel', resetSwipe, { passive: true });
    }

    for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
  })();


  // ── 3. CURSOR SPARKLE PARTICLE SYSTEM ───────────────────────
  // Desktop only. prefers-reduced-motion safe.
  (function initSparkle() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Desktop only — skip touch-primary devices
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var MAX_PARTICLES        = 400;
    var STAR_PROBABILITY     = 0.6;
    var MOVE_IDLE_DELAY_MS   = 80;
    var MOVE_SPEED_THRESHOLD = 1;
    var TELEPORT_THRESHOLD   = 300;
    var GRAVITY              = 0.018;
    var SPAWN_BASE_RATE      = 0.8;
    var SPAWN_SPEED_FACTOR   = 0.4;
    var SPAWN_JITTER_PX      = 3;

    var SPARKLE_COLORS = [
      [255, 235, 120],
      [255, 215,  60],
      [255, 200,  80],
      [220, 175,  70],
      [255, 250, 190],
      [200, 160,  50]
    ];

    // Canvas
    var canvas = document.createElement('canvas');
    canvas.className = 'jt-fn-sparkle-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');

    function resizeCanvas() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width  = window.innerWidth  * dpr;
      canvas.height = window.innerHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    var POINTER_UNSET = -999;
    var pointer = { x: POINTER_UNSET, y: POINTER_UNSET, prevX: POINTER_UNSET, prevY: POINTER_UNSET, vx: 0, vy: 0, isMoving: false };
    var idleTimer = null;

    function snapPointerTo(x, y) {
      pointer.x = x; pointer.y = y;
      pointer.prevX = x; pointer.prevY = y;
      pointer.vx = 0; pointer.vy = 0;
      pointer.isMoving = false;
      clearTimeout(idleTimer);
    }

    function trackPointer(x, y) {
      var isInitial = pointer.x === POINTER_UNSET;
      var dx = isInitial ? 0 : x - pointer.x;
      var dy = isInitial ? 0 : y - pointer.y;
      var speed = Math.sqrt(dx * dx + dy * dy);
      if (isInitial || speed > TELEPORT_THRESHOLD) { snapPointerTo(x, y); return; }
      pointer.prevX = pointer.x; pointer.prevY = pointer.y;
      pointer.x = x; pointer.y = y;
      pointer.vx = dx; pointer.vy = dy;
      if (speed <= MOVE_SPEED_THRESHOLD) return;
      pointer.isMoving = true;
      startAnimation();
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { pointer.isMoving = false; }, MOVE_IDLE_DELAY_MS);
    }

    window.addEventListener('mousemove', function (e) { trackPointer(e.clientX, e.clientY); });

    // Particles
    var particles = [];

    function createParticle(x, y) {
      var angle = Math.random() * Math.PI * 2;
      var force = 0.15 + Math.random() * 0.6;
      var isStar = Math.random() < STAR_PROBABILITY;
      return {
        x: x, y: y,
        vx: Math.cos(angle) * force,
        vy: Math.sin(angle) * force - 0.3 - Math.random() * 0.4,
        life: 1.0,
        decay: 0.006 + Math.random() * 0.009,
        size: isStar ? 3 + Math.random() * 7 : 1.2 + Math.random() * 2.5,
        color: SPARKLE_COLORS[Math.floor(Math.random() * SPARKLE_COLORS.length)],
        isStar: isStar,
        rotation: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.03,
        twinkle: Math.random() * Math.PI * 2,
        drag: 0.94 + Math.random() * 0.04
      };
    }

    function spawnAlongPath(count) {
      for (var i = 0; i < count; i++) {
        if (particles.length >= MAX_PARTICLES) return;
        var t = Math.random();
        var jx = (Math.random() - 0.5) * SPAWN_JITTER_PX;
        var jy = (Math.random() - 0.5) * SPAWN_JITTER_PX;
        particles.push(createParticle(
          pointer.prevX + (pointer.x - pointer.prevX) * t + jx,
          pointer.prevY + (pointer.y - pointer.prevY) * t + jy
        ));
      }
    }

    function drawStar(p, alpha, size) {
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rotation);
      ctx.globalAlpha = alpha;
      var inner = size * 0.22;
      ctx.beginPath();
      for (var i = 0; i < 8; i++) {
        var a   = (Math.PI / 4) * i - Math.PI / 2;
        var rad = i % 2 === 0 ? size : inner;
        var px  = Math.cos(a) * rad;
        var py  = Math.sin(a) * rad;
        i === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py);
      }
      ctx.closePath();
      var rgb = p.color[0] + ',' + p.color[1] + ',' + p.color[2];
      ctx.shadowColor = 'rgba(' + rgb + ',0.8)';
      ctx.shadowBlur = 8;
      ctx.fillStyle = 'rgb(' + rgb + ')';
      ctx.fill();
      ctx.restore();
    }

    function drawDot(p, alpha, size) {
      ctx.save();
      ctx.globalAlpha = alpha;
      var rgb = p.color[0] + ',' + p.color[1] + ',' + p.color[2];
      ctx.shadowColor = 'rgba(' + rgb + ',0.8)';
      ctx.shadowBlur = 6;
      ctx.beginPath();
      ctx.arc(p.x, p.y, size, 0, Math.PI * 2);
      ctx.fillStyle = 'rgb(' + rgb + ')';
      ctx.fill();
      ctx.restore();
    }

    function updateParticle(p) {
      p.x += p.vx; p.y += p.vy;
      p.vy += GRAVITY;
      p.vx *= p.drag; p.vy *= p.drag;
      p.life -= p.decay;
      p.rotation += p.rotSpeed;
      p.twinkle += 0.08;
    }

    function renderParticle(p) {
      var flicker = p.isStar ? 0.8 + 0.2 * Math.sin(p.twinkle * 3) : 1;
      var alpha   = Math.pow(p.life, 1.4) * flicker;
      var size    = p.size * (0.6 + 0.4 * Math.min(1, p.life * 3));
      p.isStar ? drawStar(p, alpha, size) : drawDot(p, alpha, size);
    }

    var spawnAccumulator = 0;
    var rafRunning = false;

    function tickSpawn() {
      if (!pointer.isMoving) { spawnAccumulator = 0; return; }
      var speed = Math.sqrt(pointer.vx * pointer.vx + pointer.vy * pointer.vy);
      spawnAccumulator += speed * SPAWN_SPEED_FACTOR + SPAWN_BASE_RATE;
      var count = Math.floor(spawnAccumulator);
      spawnAccumulator -= count;
      spawnAlongPath(count);
    }

    function startAnimation() {
      if (rafRunning) return;
      rafRunning = true;
      requestAnimationFrame(animate);
    }

    function animate() {
      tickSpawn();
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      for (var i = particles.length - 1; i >= 0; i--) {
        updateParticle(particles[i]);
        if (particles[i].life <= 0) { particles.splice(i, 1); continue; }
        renderParticle(particles[i]);
      }
      if (particles.length > 0 || pointer.isMoving) {
        requestAnimationFrame(animate);
      } else {
        rafRunning = false;
      }
    }
  })();

})();
